import { Spin } from 'antd';
import { LoaderStyle } from './Loader.jss';
import React, { FC } from 'react';

const Loader: FC = () => {
    const style = LoaderStyle();
    return (
        <div className={style.loaderContainer}>
            <Spin size="large" />
        </div>
    );
};

export default Loader;
